module.exports = __webpack_public_path__ + "img/DSC02321.054f53c7.jpg";